import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const OverviewPage = lazy(() => import('./pages/Overview'));
const EncountersPage = lazy(() => import('./pages/Encounters'));
const FinancePage = lazy(() => import('./pages/Finance'));
const VouchersPage = lazy(() => import('./pages/Vouchers'));
const SchedulesPage = lazy(() => import('./pages/Schedules'));

const fr = (el: React.ReactNode) => <RequireAuth roles={['FRANCHISEE']}>{el}</RequireAuth>;

/** Painel do franqueado (T-42..T-45). */
const routes: RouteObject[] = [
  { path: '/franqueado', element: fr(<OverviewPage />) },
  { path: '/franqueado/atendimentos', element: fr(<EncountersPage />) },
  { path: '/franqueado/vouchers', element: fr(<VouchersPage />) },
  { path: '/franqueado/financeiro', element: fr(<FinancePage />) },
  { path: '/franqueado/horarios', element: fr(<SchedulesPage />) },
];
export default routes;
